<template>
    <div class="d-flex flex-wrap date-range justify-space-between pb-2">
        <div class="">
            <label class="control-label">Days of the week</label>
            <div class="d-flex flex-wrap justify-center">

                <div class="checkbox" v-for="(day) in weekdayOptions">
                    <input type="checkbox" name="day" @change="toggleDay(day)" :value="day.value" :checked="dayIsToggled(day)"> {{ day.text }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
* A Vue component for the user to select which days of the week they would like the batch loader to update when changes are submitted
*
*/

export default {
    name: 'hotel-batch-loader-weekday-controls',
    props: ['selectedDays'],
    data () {
        return { 
            weekdayOptions: [
                { text: 'Monday', value: 1 },
                { text: 'Tuesday', value: 2},
                { text: 'Wednesday', value: 3},
                { text: 'Thursday', value: 4},
                { text: 'Friday', value: 5},
                { text: 'Saturday', value: 6},
                { text: 'Sunday', value: 7}
            ],
        }
    },

    methods: {
        toggleDay(day){
            this.$emit('toggle-day', day.value);
        },

        dayIsToggled(day){
            return this.selectedDays.includes(day.value);
        }
    },

    /**
     * Once mounted this component needs to load all available models
     */
    mounted() {
    },

    computed: {

    },

    watch: 
        {
    }
}
</script>

<style>
    
</style>
